import { isNumber } from "lodash";
import React from "react";
import {
  approxPoppySurprise,
  benignStrongColor,
  defaultPathogenicityColor,
  pathogenicStrongColor,
  uncertainSignificanceColor,
} from "../../../../common/helpers/colors";
import { cropNumber } from "../../../../common/helpers/helpers";
import { DBNSFP_CONSERVATION_FIELDS } from "./constants";
import HelperText from "../../../../components/atoms/HelperText";

export const checkIfResultIsEmpty = (dbnsfp) => {
  let i = 0;
  let found = false;

  while (DBNSFP_CONSERVATION_FIELDS.length > i && found === false) {
    if (dbnsfp[DBNSFP_CONSERVATION_FIELDS[i]] != null) {
      found = true;
    }
    i += 1;
  }
  return found;
};

export const calculateMedian = (numbers) => {
  let median = 0;
  const numsLen = numbers.length;
  numbers.sort();
  if (numsLen % 2 === 0) {
    // is even
    // average of two middle numbers
    median = (numbers[numsLen / 2 - 1] + numbers[numsLen / 2]) / 2;
  } else {
    // is odd
    // middle number only
    median = numbers[(numsLen - 1) / 2];
  }
  return median;
};

export const calculateMean = (numbers) => {
  const values = numbers.filter((k) => k !== null);
  return values.length > 0
    ? values.reduce((accumulator, currentValue) => accumulator + currentValue) /
        values.length
    : null;
};

export const calculateMax = (arr) => {
  return arr.reduce((max, val) => (max > val ? max : val));
};

export const calculateMin = (arr) => {
  return arr.reduce((min, val) => (min < val ? min : val));
};

export const getColor = (db, score, thresholds) => {
  const conserved = `${db}_conserved`;
  const inSilicoPredictionsThreshHolds = {
    benign: thresholds?.[`${db}_benign`] || undefined,
    pathogenic: thresholds?.[`${db}_pathogenic`] || undefined,
  };
  if (
    inSilicoPredictionsThreshHolds.benign ||
    isNumber(inSilicoPredictionsThreshHolds.benign) ||
    inSilicoPredictionsThreshHolds.pathogenic ||
    isNumber(inSilicoPredictionsThreshHolds.pathogenic)
  ) {
    if (score >= inSilicoPredictionsThreshHolds.pathogenic) {
      return pathogenicStrongColor;
    }
    if (score <= inSilicoPredictionsThreshHolds.benign) {
      return benignStrongColor;
    }
    return uncertainSignificanceColor;
  }
  if (thresholds && score >= thresholds[conserved]) {
    return approxPoppySurprise;
  }
  return defaultPathogenicityColor;
};

export const renderMultipleCommasWithDescription = (
  item,
  prop,
  label = "",
  crop = false,
  helpTextKey,
  splitLabel = true,
  color = false,
  thresholds = null,
  db = null
) => {
  if (Array.isArray(item[prop]) && item[prop].length > 0) {
    const filteredFromNull = item[prop].filter((x) => x !== null);
    return (
      <td>
        <div className="varsome-horiz-list-label varsome-dbnsfp-label">
          {splitLabel && label.split(" ").slice(1).join(" ")}
          {!splitLabel && label}
          {helpTextKey && <HelperText fieldDescriptionKey={helpTextKey} />}
        </div>
        <div className="varsome-horiz-list-value">
          {filteredFromNull.map((value, i) => {
            const c = color ? getColor(db, value, thresholds) : "";
            return (
              <span key={i} style={{ color: c }}>
                {crop ? cropNumber(value) : value}
                {i < filteredFromNull.length - 1 ? ", " : ""}
              </span>
            );
          })}
        </div>
      </td>
    );
  }
  if (item[prop]) {
    const c = color ? this.getColor(db, item[prop], thresholds) : "";
    return (
      <td>
        <div className="varsome-horiz-list-label varsome-dbnsfp-label">
          {splitLabel && label.split(" ").slice(1).join(" ")}
          {!splitLabel && label}
          {helpTextKey && <HelperText fieldDescriptionKey={helpTextKey} />}
        </div>

        <div className="varsome-horiz-list-value" style={{ color: c }}>
          {crop ? cropNumber(item[prop]) : item[prop]}
        </div>
      </td>
    );
  }
  return <td />;
};
